<div class="top-section">
    <h3>
        Plans
    </h3>
</div>

<section class="rate-request rate-request-sec">
    <div class="middle-section">
        <div class="container">
            <div class="rate-request-form">
                <div class="rate-request-form-inner">                    
                    <div class="request-btn">
                        <input type="text" class="form-control" pInputText size="50" placeholder="Search"
                            (change)="filterSearch($event.target.value)">
                        <div class="btn-search"><button class="btn  btn-go my-2 my-sm-0" type="submit"><img
                                    src="../../../assets/images/Group 103.svg"></button></div>
                    </div>
                </div>
                <div class="table-responsive rate-request-tbl">

                    <p-table [value]="plandata">

                        <ng-template pTemplate="header">
                            <tr>
                                <th>Plan Name</th>
                                <th>Plan Cost</th>
                                <th>No Of Users</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-plan>
                            <tr>
                                <td>{{ plan.planeName }}</td>
                                <td>{{ plan.price }}</td>
                                <td>{{ plan.noOfUsers }}</td>
                                <td>                                                                      

                                    <a class="action-btn " tooltipPosition="top" pTooltip="Edit Plan"
                                        data-toggle="modal" data-target=".view-offredrate"
                                        (click)="openPlanModal(plan.planId)">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <p-paginator *ngIf="totalcount > 0" [rows]="requestVM.pageSize" [rowsPerPageOptions]="[5,10,20]"
                    [totalRecords]="totalcount" (onPageChange)="paginate($event)"></p-paginator>
                <div *ngIf="totalcount == 0">
                    <span>No records found</span>
                </div>
            </div>
        </div>
    </div>
</section>


<ng-template #planModal let-modal>
  <div class="modal-header">
    <h3>Edit Plan</h3>
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <form [formGroup]="planEditform" (ngSubmit)="UpdatePlan()">
    <div class="modal-dialog modal-lg">
      <div class="modal-content text-left">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-5 form-group">
              <label class="custom-labal "> Plan Name </label>
              <input type="text" class="form-control" formControlName="planname" [ngClass]="{ 'is-invalid':(submitted && fn.planname.errors) || ( fn.planname.errors && fn.planname.touched) || (fn.planname.errors && fn.planname.dirty)}" />
              <div *ngIf="(submitted && fn.planname.errors) || ( fn.planname.errors && fn.planname.touched) || (fn.planname.errors && fn.planname.dirty)" class="invalid-feedback">
                <div class="port-error " *ngIf="fn.planname.errors.required"> Plan Name is required</div>
                <div class="port-error " *ngIf="fn.planname.errors.maxlength">Plan Name can be max 30 characters long</div>
              </div>
            </div>
            <div class="col-md-5 form-group">
              <label class="custom-labal "> Plan Cost($) </label>
              <input type="text" formControlName="plancost" class="form-control" [ngClass]="{ 'is-invalid':(submitted && fn.plancost.errors) || ( fn.plancost.errors && fn.plancost.touched) || (fn.plancost.errors && fn.plancost.dirty)}" />
              <div *ngIf="(submitted && fn.plancost.errors) || ( fn.plancost.errors && fn.plancost.touched) || (fn.plancost.errors && fn.plancost.dirty)" class="invalid-feedback">
                <div class="port-error " *ngIf="fn.plancost.errors.required"> Plan Cost is required</div>
                <div class="port-error " *ngIf="fn.plancost.errors.maxlength">Plan Cost can be max 10 characters long</div>
              </div>
            </div>
            <div class="col-md-2 form-group">
              <label class="custom-labal "> Is Plan Active </label>
              <p-inputSwitch formControlName="isPlanActive"></p-inputSwitch>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 form-group pt-2 pb-3">
              <label class="custom-labal pb-1 ">Plan Description </label>
              <p-editor
                formControlName="description"
                [style]="{ height: '150px' }"
                placeholder="Enter plan description">
              </p-editor>
              <div *ngIf="(submitted && fn.description.errors) || ( fn.description.errors && fn.description.touched) || (fn.description.errors && fn.description.dirty)" class="invalid-feedback">
                <div class="port-error " *ngIf="fn.description.errors.required"> Plan description is required</div>
              </div>
            </div>
            
          </div>
          <div *ngFor="let data of plandetails; index as i">
            <div class="row">
              <div class="col-md-6">
                <label>{{data.searchCategoryName}}</label>
              </div>
              <div class="col-md-6">
                <p-inputSwitch [(ngModel)]="data.isActiveInPlan" [ngModelOptions]="{standalone: true}" (onChange)="handleChange($event,data.searchCatId)"></p-inputSwitch>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-signIn">Update</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
